module.exports = __webpack_public_path__ + "static/media/invalid-document.c9344e50.png";